import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/Global.scss';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
// import Route from "react-router-dom";
import App from './Routes/HomePage.js';
import AccountTypeSelection from './Components/AccountTypeSelection.js';
import RegistrationCampSelection from './Routes/RegistrationCampSelection.js';
import CreateIndividualAccount from './Routes/CreateIndividualAccount.js';
import DayCampRegistration from './Routes/DayCampRegistration.js'
import IndividualRegistration from './Routes/IndividualRegistration.js';
import GroupReservation from './Routes/GroupReservation.js';
import GroupAccount  from "./Routes/GroupAccount.js";
import CreateGroupAccount from './Routes/CreateGroupAccount.js';
import IndividualsAccountDashboard from './Routes/IndividualsAccountDashboard.js';
import AdministrationPortal from './Routes/AdministrationPortal.js';
import AboutHistory from './Routes/AboutHistory.js';
import AboutMission from './Routes/AboutMission.js';
import AboutGoodNews from './Routes/AboutGoodNews.js';
import AboutStaff from './Routes/AboutStaff.js';
import AboutGetInvolved from './Routes/AboutGetInvolved.js';
import CampsAdults from './Routes/CampsAdults.js';
import CampsDeaf from './Routes/CampsDeaf.js';
import CampsFamily from './Routes/CampsFamily.js';
import CampsJuniors from './Routes/CampsJuniors.js';
import JuniorHome from './Routes/JuniorHome.js';
import UpdateIndividualInformation from './Routes/UpdateIndividualInformation';
import DeleteRegistration from './Routes/DeleteRegistration.js'; 
import EditRegistration from './Routes/EditRegistration.js'; 
import CampsTeens from './Routes/CampsTeens.js';
import FirstLightNav from './Routes/FirstLight.js';
import Store from './Routes/Store.js';
import AddTransaction from './Routes/AddTransaction.js';
import EventReporting from './Routes/EventReporting.js'
// import Give from './Routes/Give.js';
import EditReview from './Routes/EditReview.js'
import AdminHome from './Routes/AdminHome.js';
import RetreatRegistration from './Routes/RetreatRegistration.js';
import RetreatGroupReservation from './Routes/RetreatGroupReservation.js';
import RetreatPaymentSuccess from './Routes/RetreatPaymentSuccess.js';
import Session from 'react-session-api';
import Contact from './Routes/Contact.js';
import CreateIndividualReview from './Routes/CreateIndividualReview.js';
import CreateGroupReview from './Routes/CreateGroupReview.js';
import DayCampJuniors from './Routes/DayCampJuniors.js';
import UpdateIndividualRegistration from './Routes/UpdateIndividualRegistration.js';
import RegistrationSearch from './Routes/RegistrationSearch.js';
import ReservationSearch from './Routes/ReservationSearch.js';
import GroupAccountSearch from './Routes/GroupAccountSearch.js';
import AccountSearch from './Routes/AccountSearch.js';
import AdminDayCampRegistration from './Routes/AdminDayCampRegistration.js';
import ViewTransactionHistory from './Components/ViewTransactionHistory.js';
import DayCampPaymentSuccess from './Routes/DayCampPaymentSuccess.js';
import ReservationPaymentSuccess from './Routes/ReservationPaymentSuccess.js'; 
import AddPayment from './Routes/AddPayment.js';
import ResetPasswordForm from './Routes/ResetPasswordForm.js';
import MyCart from './Routes/MyCart.js';
import MakePayment from './Routes/MakePayment.js';
import { CartProvider } from './Contexts/CartContext.js';

const IndividualRoutes = () => {

  return(<>{Session.get("isAuth") === "true" && Session.get("accountType") == 'individual' ? <Outlet />  : <Navigate to='/'/>}</>)
}

const GroupRoutes = () => {

   return(<>{Session.get("isAuth") === "true" && Session.get("accountType") == 'group' ? <Outlet />  : <Navigate to='/'/>}</>)
 }

 const AdminRoutes = () => {

   return(<>{Session.get("isAuth") === "true" && Session.get("accountType") == 'admin' ? <Outlet />  : <Navigate to='/'/>}</>)
 }


const RestrictedRoutes = () => {

  return(<>{Session.get("isAuth") !== "true" && Session.get("accountType") !== 'admin' ? <Outlet /> : Session.get("isAuth") === "true" && Session.get("accountType") == 'admin' ?  <Navigate to="/administration"/> : Session.get("isAuth") == "true" && Session.get("accountType") == "individual" ? <Navigate to='/individualaccount'/> : <Navigate to="/groupaccount"/>}</>)
} 
 
const root = ReactDOM.createRoot(document.getElementById('root'));
Session.config(true, 0)
root.render(
  // CartProvider wraps the router so the navbar badge is available on every page, and so adding a
  // registration anywhere updates the count without a reload.
  <CartProvider>
  <BrowserRouter>
        <Routes>
      {/* Home page */}
      <Route path="/history" element={<AboutHistory />}/>
      <Route path="/mission" element={<AboutMission />}/>
      <Route path="/goodnews" element={<AboutGoodNews />}/>
      <Route path="/staff" element={<AboutStaff />}/>
      <Route path="/getinvolved" element={<AboutGetInvolved />}/>
      <Route path="/adults" element={<CampsAdults />}/>
      <Route path="/deaf" element={<CampsDeaf />}/>
      <Route path="/family" element={<CampsFamily />}/>
      <Route path="/juniors" element={<CampsJuniors />}/>
      <Route path="/juniorsdaycamp" element={<DayCampJuniors />}/>
      <Route path="/teens" element={<CampsTeens />}/>
      <Route path="/ministryresources" element={<FirstLightNav />}/>
      <Route path="/store" element={<Store />}/>
      <Route path="/juniorhome" element={<JuniorHome/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="/reset-password" element={<ResetPasswordForm/>}/>


      {/* Private routes go in here*/}
      <Route element={<IndividualRoutes/>}>
      <Route path="/individualregistration" element={<IndividualRegistration />}/>
      <Route path="/updateindividualregistration/:id" element={<UpdateIndividualRegistration />}/>
      <Route path="/individualaccount" element={<IndividualsAccountDashboard />}/>
      <Route path="/registrationcampselection" element={<RegistrationCampSelection />}/>
      <Route path="/updateindividualinformation" element={<UpdateIndividualInformation />}/>
      <Route path="/editregistration" element={<EditRegistration />}/>
      <Route path="/deleteregistration" element={<DeleteRegistration />}/>
      <Route path="/updateindividualinformation" element={<UpdateIndividualInformation />}/>
      <Route path="/editreview" element={<EditReview/>}/>
      <Route path="/createindividualreview" element={<CreateIndividualReview/>}/>
      <Route path="/daycampregistration" element={<DayCampRegistration />}/>
      <Route path="/daycamppaymentsuccess" element={<DayCampPaymentSuccess/>}/>
      <Route path="/retreatregistration" element={<RetreatRegistration />}/>
      <Route path="/retreatpaymentsuccess" element={<RetreatPaymentSuccess/>}/>
      <Route path="/addPayment" element={<AddPayment/>}/>
      <Route path="/mycart" element={<MyCart/>}/>
      <Route path="/makepayment" element={<MakePayment/>}/>
      </Route>

      <Route element={<GroupRoutes/>}>
      <Route path="/groupreservation" element={<GroupReservation />}/>
      <Route path="/retreatgroupreservation" element={<RetreatGroupReservation />}/>
      <Route path="/groupaccount" element={<GroupAccount />}/>
      <Route path="/creategroupreview" element={<CreateGroupReview/>}/>
      <Route path="/reservationpaymentsuccess" element={<ReservationPaymentSuccess/>}/>
      </Route>

      <Route element={<AdminRoutes/>}>
         <Route path="/administration" element={<AdministrationPortal />}/>
         <Route path="/groupaccountsearch" element={< GroupAccountSearch />}/>
         <Route path="/registrationsearch" element={<RegistrationSearch />}/>
         <Route path="/reservationsearch" element={<ReservationSearch />}/>
         <Route path="/accountsearch" element={<AccountSearch />}/>
         <Route path="/admindaycampregistration" element={<AdminDayCampRegistration />}/>
         <Route path="/reporting" element={<EventReporting />}/>
         <Route path="/addtransaction/:id" element={<AddTransaction/>} />
         <Route path="/viewtransactionhistory/:id" element={<ViewTransactionHistory/>}
         />
      </Route>

      {/* Restricted routes go in here*/}
      <Route element={<RestrictedRoutes/>}>
      <Route path="/" element={<AccountTypeSelection />}/>
      <Route path="/createIndividualAccount" element={<CreateIndividualAccount />}/>
      <Route path="/creategroupaccount" element={<CreateGroupAccount />}/>
      <Route path="/adminhome" element={<AdminHome />}/>
      </Route>
      
    </Routes>


  </BrowserRouter>
  </CartProvider>
);
